import React, { useState } from 'react'
import {
	useSelector,
	useDispatch
} from 'react-redux'
import {
	selectAllTags,
	updateTagColor,
	deleteTag,
	updateTagName,
	createTag
} from '../../state/accountTagsSlice'
import { DebounceInput } from 'react-debounce-input';
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Popover from 'react-bootstrap/Popover'
import Form from 'react-bootstrap/Form'
import InputGroup from 'react-bootstrap/InputGroup'
import { CirclePicker } from 'react-color'
import { getAllClients } from "../users/usersSlice"


const EditableTag = ({ tag, setTagFilters }) => {
	const dispatch = useDispatch()
	const { color } = tag
	const colorChangeHandler = (colorObj) => {
		const { hex } = colorObj
		dispatch(updateTagColor({
			tag_id: tag.id,
			color: hex
		}))
	}
	const nameChangeHandler = (name) => {
		dispatch(updateTagName({
			tag_id: tag.id,
			name
		}))
			.then(() => setTagFilters(new Set([])))
			.then(dispatch(getAllClients()))
	}
	const deleteTagHandler = () => {
		if (!window.confirm('Delete this tag from your account AND all clients?')) return
		dispatch(deleteTag(tag.id))
	}
	return (
		<span style={{ position: 'relative' }} className="m-1">
			<InputGroup>
				<InputGroup.Prepend>
					<OverlayTrigger rootClose trigger="click" placement="top" overlay={
						<Popover>
							<Popover.Content>
								<CirclePicker onChangeComplete={colorChangeHandler} />
							</Popover.Content>
						</Popover>
					}>
						<button style={{
							width: '24px',
							background: color,
							border: 'none'
						}} />
					</OverlayTrigger>
				</InputGroup.Prepend>
				<DebounceInput
					minLength={0}
					debounceTimeout={400}
					value={tag.name}
					className={["form-control", "form-control-sm", "pl-1"].join(' ')}
					placeholder="option name"
					onChange={e => nameChangeHandler(e.target.value)}
				/>
			</InputGroup>
			<i
				onClick={deleteTagHandler}
				style={{
					position: 'absolute',
					top: '-4px',
					right: '-4px',
					width: '12px',
					height: '12px'
				}} className="fa fa-times text-danger"> </i>
		</span>
	)
}

const TagManager = ({ show, onHide, setTagFilters }) => {
	const dispatch = useDispatch()
	const tags = useSelector(selectAllTags)
	const [error, setError] = useState(false)
	const [newTag, setNewTag] = useState('')
	let colors = ["f44336", "e91e63", "9c27b0", "673ab7", "3f51b5", "2196f3",
		"03a9f4", "00bcd4", "009688", "4caf50", "8bc34a", "cddc39", "ffeb3b",
		"ffc107", "ff9800", "ff5722", "795548", "607d8b"]

	function randomColor(colors) {
		return colors[Math.floor(Math.random() * colors.length)];
	}

	const createTagHandler = () => {
		if (!Boolean(newTag)) {
			setError(true)
		} else {
			randomColor = randomColor(colors)
			dispatch(createTag({tag_name: newTag,color:randomColor}));
			setNewTag('')

		}
	}
	return (
		<Modal centered size="lg" show={show} onHide={onHide}>
			<Modal.Header closeButton>
				<Modal.Title>Manage Client Tags</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				{tags.length === 0 &&
					<p>
						These are tags that can be added to clients and can be used to quickly filter the client list.
						To add a tag to a client, click on the client's name and find the "Tags" section.
					</p>
				}
				<div>
					<InputGroup className="mb-3">
						<Form.Control
							className={error && 'border-danger'}
							value={newTag}
							onChange={e => {
								setError(false)
								setNewTag(e.target.value)
							}}
							placeholder="create new tag"
							aria-label="create new tag" />
						<InputGroup.Append>
							<Button
								onClick={createTagHandler}
								variant="outline-secondary">
								<i className="fa fa-plus" />
							</Button>
						</InputGroup.Append>
					</InputGroup>
				</div>
				{tags.length > 0 &&
					<p className="text-center">Click on a tag to edit it</p>
				}
				<div className="d-flex flex-wrap justify-content-center">
					{tags.map(tag => <EditableTag tag={tag} setTagFilters={setTagFilters} />)}
				</div>
			</Modal.Body>
		</Modal>
	)
}

export default TagManager